// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"_1FTQpO","icon":"_3xngAD","counter":"L92uYZ","notEmpty":"_1tTP-2"};